import { getAppHost } from 'helpers'
import { getChatApiBase, getChatApiHeaders } from './chatApiClient'
import axios from './axiosInstance'

const getHeaders = app => ({ ...getChatApiHeaders(app), chatapiversion: 'v3.0' })

const getBaseURL = (app, appSettings) => {
  const apiHost = getAppHost(appSettings)
  return `${getChatApiBase(app, apiHost)}/ai-agents/agent-builder/frontend-actions`
}

const getAgentBaseURL = (app, appSettings) => {
  const apiHost = getAppHost(appSettings)
  return `${getChatApiBase(app, apiHost)}/ai-agents/agent-builder/agents`
}

// List Frontend Actions
export const list = async (app, appSettings, pageNo = 1, searchText = '', cursor) => {
  try {
    const baseURL = getBaseURL(app, appSettings)

    const params = new URLSearchParams()
    if (pageNo) params.append('page', pageNo)
    if (searchText) params.append('search', searchText)
    // The API pages by cursor and ignores `page`.
    if (cursor && cursor.affix) {
      params.append('affix', cursor.affix)
      params.append('createdAt', cursor.createdAt)
    }

    const url = params.toString() ? `${baseURL}?${params.toString()}` : baseURL

    const response = await axios.get(url, {
      headers: getHeaders(app),
    })

    return response.data
  } catch (error) {
    throw error
  }
}

// Create Frontend Action
export const create = async (app, appSettings, actionData) => {
  try {
    const baseURL = getBaseURL(app, appSettings)

    const response = await axios.post(baseURL, actionData, {
      headers: getHeaders(app),
    })

    return response.data
  } catch (error) {
    throw error
  }
}

// Update Frontend Action
export const update = async (app, appSettings, actionId, actionData) => {
  try {
    const baseURL = getBaseURL(app, appSettings)
    const url = `${baseURL}/${encodeURIComponent(actionId)}`

    const response = await axios.patch(url, actionData, {
      headers: getHeaders(app),
    })

    return response.data
  } catch (error) {
    throw error
  }
}

// Delete Frontend Action
export const remove = async (app, appSettings, actionId) => {
  try {
    const baseURL = getBaseURL(app, appSettings)
    const url = `${baseURL}/${encodeURIComponent(actionId)}`

    const response = await axios.delete(url, {
      headers: getHeaders(app),
    })

    return response.data
  } catch (error) {
    throw error
  }
}

// Toggle Frontend Action enabled status for an agent
// enabled=true: Add frontend action to agent
// enabled=false: Remove frontend action from agent
export const toggle = async (app, appSettings, agentUid, triggerFunction, enabled) => {
  try {
    const baseURL = getAgentBaseURL(app, appSettings)
    const action = enabled ? 'add' : 'remove'
    const url = `${baseURL}/${encodeURIComponent(agentUid)}/frontend-actions/${action}`

    const response = await axios.patch(
      url,
      { frontendActions: [triggerFunction] },
      { headers: getHeaders(app) },
    )

    return response.data
  } catch (error) {
    throw error
  }
}

// Add multiple frontend actions to an agent
export const addToAgent = async (app, appSettings, agentUid, triggerFunctions) => {
  try {
    const baseURL = getAgentBaseURL(app, appSettings)
    const url = `${baseURL}/${encodeURIComponent(agentUid)}/frontend-actions/add`

    const response = await axios.patch(
      url,
      { frontendActions: triggerFunctions },
      { headers: getHeaders(app) },
    )

    return response.data
  } catch (error) {
    throw error
  }
}

// Remove multiple frontend actions from an agent
export const removeFromAgent = async (app, appSettings, agentUid, triggerFunctions) => {
  try {
    const baseURL = getAgentBaseURL(app, appSettings)
    const url = `${baseURL}/${encodeURIComponent(agentUid)}/frontend-actions/remove`

    const response = await axios.patch(
      url,
      { frontendActions: triggerFunctions },
      { headers: getHeaders(app) },
    )

    return response.data
  } catch (error) {
    throw error
  }
}
